export default __webpack_public_path__ + "static/media/github.c09e4ff4.png";